import http from 'utils/http';
import { BusinessProfileResponse } from 'apis/business/types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getAgencyAgentsUrl, getBusinessesUrl, getBusinessUrl, getResetBusinessUrl } from './apiUrls';

export function getBusinesses(
  params?: Record<string, any>
): Promise<{ data: BusinessProfileResponse[]; meta: MetaApiResponse }> {
  return http.get(getBusinessesUrl(), params);
}

export function getBusiness(id: number, params?: Record<string, any>): Promise<BusinessProfileResponse> {
  return http.get(getBusinessUrl(id), params);
}

export function getDeleteBusiness(id: number): Promise<{ data: BusinessProfileResponse[] }> {
  return http.delete(getBusinessUrl(id));
}

export function createBusiness(payload: FormData): Promise<BusinessProfileResponse> {
  return http.post(getBusinessesUrl(), payload);
}

export function updateBusiness(id: number, payload: any): Promise<BusinessProfileResponse> {
  return http.put(getBusinessUrl(id), payload);
}

export function resetBusiness(id: number): Promise<any> {
  return http.post(getResetBusinessUrl(id), {});
}

export function getAgencyAgents(params?: Record<string, any>): Promise<{ data: any[]; meta: MetaApiResponse }> {
  return http.get(getAgencyAgentsUrl(), params);
}
